<template>
  <DragDialog
    :title="`${permissionInfo ? '编辑' : '新增'}权限`"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel"
    class="permissionManage">
    <el-form
      class="common-form-box public-form-primary"
      :model="form"
      :rules="rules"
      label-width="100px"
      ref="form">
      <el-form-item label="父级功能:">
        <span class="dialog-label">{{ parentInfo.menuName }}</span>
      </el-form-item>
      <el-form-item
        label="权限类型:"
        prop="menuType">
        <div class="common-select-box">
          <el-select
            class="primary-select"
            size="small"
            v-model="form.menuType"
            :disabled="isMenuTypeDisabled()"
            :popper-append-to-body="false">
            <el-option
              v-for="item in menuTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value" />
          </el-select>
        </div>
      </el-form-item>
      <el-form-item
        :label="`${getMenuName()}名称`"
        prop="menuName">
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="small"
            v-model="form.menuName"
            :placeholder="`请输入${getMenuName()}名称`" />
        </div>
      </el-form-item>
      <el-form-item
        v-if="form.menuType !== 'module'"
        label="权限编码:"
        prop="permissionCode">
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="small"
            v-model="form.permissionCode"
            placeholder="请确认权限编码" />
        </div>
      </el-form-item>
      <el-form-item
        v-if="form.menuType === 'page'"
        label="访问路径:"
        prop="pageUrl">
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="small"
            v-model="form.pageUrl"
            placeholder="请输入访问路径" />
        </div>
      </el-form-item>
      <el-form-item
        label="权限图标:"
        prop="iconPath">
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="small"
            v-model="form.iconPath"
            placeholder="请输入图标地址" />
        </div>
      </el-form-item>
      <el-form-item label="排序:">
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="small"
            v-model="form.viewIndex"
            placeholder="请输入排序" />
        </div>
      </el-form-item>
      <el-form-item
        label="状态:"
        prop="status">
        <div class="common-switch-box">
          <el-switch
            class="switch-primary"
            v-model="form.status" />
        </div>
      </el-form-item>
      <el-form-item :label="`${getMenuName()}说明`">
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="small"
            type="textarea"
            :rows="5"
            v-model="form.remark"
            placeholder="添加权限说明，便于记忆哦" />
        </div>
      </el-form-item>
    </el-form>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'
import {
  createPage,
  createModule,
  createFeature,
  modifyPage,
  modifyModule,
  modifyFeature
} from '@/service/interface'
export default {
  data() {
    return {
      form: {
        menuType: 'module'
      },
      menuTypeList: [
        { label: '模块', value: 'module' },
        { label: '页面', value: 'page' },
        { label: '功能', value: 'feature' }
      ],
      rules: {
        menuType: [
          {
            required: true,
            message: '请输入权限类型',
            trigger: 'blur'
          }
        ],
        menuName: [
          {
            required: true,
            message: `请输入名称`,
            trigger: 'blur'
          }
        ],
        permissionCode: [
          {
            required: true,
            message: `请输入权限编码`,
            trigger: 'blur'
          }
        ],
        pageUrl: [
          {
            required: true,
            message: `请输入访问路径`,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  props: {
    visible: Boolean,
    permissionInfo: Object,
    parentInfo: Object,
    queryPermissionMenu: Function,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    permissionInfo: function (newValue) {
      if (newValue) {
        this.form = {
          id: newValue.id,
          parentId: newValue.parentId,
          menuName: newValue.menuName,
          remark: newValue.remark,
          viewIndex: newValue.viewIndex,
          iconPath: newValue.iconPath,
          permissionCode: newValue.permissionCode,
          pageUrl: newValue.pageUrl,
          featureGroupCode: newValue.featureGroupCode,
          menuType: newValue.menuType
        }
      }
    }
  },
  methods: {
    getMenuName() {
      let find = this.menuTypeList.find(el => el.value === this.form.menuType)
      return `${find.label}`
    },
    submit() {
      let startInterval = setInterval(() => {
        this.disabled = false
        clearInterval(startInterval)
      }, 60000)

      if (!this.disabled) {
        this.$refs.form.validate((bool, object) => {
          if (bool) {
            if (!this.form.parentId) {
              this.form.parentId = this.parentInfo.id
            }
            if (this.permissionInfo) {
              if (this.form.menuType === 'page') {
                modifyPage(this.form).then(res => {
                  if (res.status === 200) {
                    let data = res.data
                    if (data.isSuccess) {
                      this.queryPermissionMenu().then(() => {
                        this.$message.success('编辑成功！！！')
                        this.disabled = false
                        this.cancel()
                      })
                    }
                  } else {
                    this.disabled = false
                  }
                })
              }
              if (this.form.menuType === 'module') {
                modifyModule(this.form).then(res => {
                  if (res.status === 200) {
                    let data = res.data
                    if (data.isSuccess) {
                      this.queryPermissionMenu().then(() => {
                        this.$message.success('编辑成功！！！')
                        this.disabled = false
                        this.cancel()
                      })
                    }
                  } else {
                    this.disabled = false
                  }
                })
              }
              if (this.form.menuType === 'feature') {
                modifyFeature(this.form).then(res => {
                  if (res.status === 200) {
                    let data = res.data
                    if (data.isSuccess) {
                      this.queryPermissionMenu().then(() => {
                        this.$message.success('编辑成功！！！')
                        this.disabled = false
                        this.cancel()
                      })
                    }
                  } else {
                    this.disabled = false
                  }
                })
              }
            } else {
              if (this.form.menuType === 'page') {
                createPage(this.form).then(res => {
                  if (res.status === 200) {
                    let data = res.data
                    if (data.isSuccess) {
                      this.queryPermissionMenu().then(() => {
                        this.$message.success('新建权限成功！！！')
                        this.disabled = false
                        this.cancel()
                      })
                    }
                  } else {
                    this.disabled = false
                  }
                })
              }
              if (this.form.menuType === 'module') {
                createModule(this.form).then(res => {
                  if (res.status === 200) {
                    let data = res.data
                    if (data.isSuccess) {
                      this.queryPermissionMenu().then(() => {
                        this.$message.success('新建权限成功！！！')
                        this.disabled = false
                        this.cancel()
                      })
                    }
                  } else {
                    this.disabled = false
                  }
                })
              }
              if (this.form.menuType === 'feature') {
                createFeature(this.form).then(res => {
                  if (res.status === 200) {
                    let data = res.data
                    if (data.isSuccess) {
                      this.queryPermissionMenu().then(() => {
                        this.$message.success('新建权限成功！！！')
                        this.disabled = false
                        this.cancel()
                      })
                    }
                  } else {
                    this.disabled = false
                  }
                })
              }
            }
          } else {
            this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
          }
          this.disabled = true
        })
      }
    },
    cancel() {
      this.form = {
        menuType: 'module'
      }
      this.closeDialog()
    },
    isMenuTypeDisabled() {
      let isDisabled = false
      // prettier-ignore
      if (this.parentInfo && this.parentInfo.id === "00000000-0000-0000-0000-000000000000") {
        isDisabled = true;
      }
      return isDisabled
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-form-box {
  color: var(--default-color);

  :deep(.el-form-item) {
    margin-bottom: 16px;
  }
  .common-select-box {
    .el-select {
      width: 100%;
    }
  }
}

.permissionManage {
  :deep(.dialog-content) {
    padding-top: 0;
  }

  .public-form-primary {
    :deep(.el-form-item) {
      &:first-child {
        margin-bottom: 0;
      }

      .el-form-item__error{
        padding-top: 0;
      }
    }
  }
}
</style>
